import React from 'react';
import { useInView } from '../utils/useInView';

type Props = {
  /** Stagger offset in ms (e.g. `delay={i * 60}`). */
  delay?: number;
  /** Pass-through wrapper classes. */
  className?: string;
  children: React.ReactNode;
};

// Fade + 8px slide-up wrapper that fires once when its element scrolls
// into view. Pre-reveal state (opacity-0 + translate-y-2) takes the
// same space as the final state so there's no layout shift.
// prefers-reduced-motion is honored globally in index.css.
const Reveal: React.FC<Props> = ({ delay = 0, className = '', children }) => {
  const { ref, inView } = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      className={`transition-all duration-500 ease-out will-change-transform ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Reveal;
